export enum SuperAdminTool {
    CorrectiveProgramArticles = "corrective_program_articles",
    DetermineCorrectiveProgram = "determine_corrective_program",
    GeneratePartnerApiKey = "generate_partner_api_key",
    NewReportViewer = "new_report_viewer",
    UploadMockDemoData = "upload_mock_demo_data",
    ExportProductionUsersToDemo = "export_production_users_to_demo",
    ManageDemoOrganizations = "manage_demo_organizations",
    MskRealAverages = "msk_real_averages",
    MskLiteDemo = "msk_lite_demo",
    AiRiskSummary = "ai_risk_summary",
    AiMskSummary = "ai_msk_summary",
    ApiKeyUsage = "api_key_usage",
    AiPartialMskSummary = "ai_partial_msk_summary",
    AiRegeneratePartialMskSummary = "ai_regenerate_partial_msk_summary",
    DataExportReport = "data_export_report",
    TestLogging = "test_logging",
    NormalizeUserEmails = "normalize_user_emails",
    FixInvalidBirthdates = "fix_invalid_birthdates"
}
